export const SORT_TYPES = {
  text: { asc: 'A \u2192 Z', desc: 'Z \u2192 A' },
  date: { asc: 'Earliest \u2192 Latest', desc: 'Latest \u2192 Earliest' },
  number: { asc: '1 \u2192 9', desc: '9 \u2192 1' },
  currency: { asc: 'Lowest \u2192 Highest', desc: 'Highest \u2192 Lowest' },
};

export const DONATION_COLUMNS = [
  { id: 'order_number', label: 'Order #', alwaysVisible: false, defaultVisible: true, sortable: true, sortType: 'number' },
  { id: 'event_name', label: 'Event', alwaysVisible: false, defaultVisible: true, sortable: true, sortType: 'text' },
  { id: 'venue_name', label: 'Venue', alwaysVisible: false, defaultVisible: true, sortable: false },
  { id: 'donation_amount', label: 'Amount', alwaysVisible: false, defaultVisible: true, sortable: true, sortType: 'currency' },
  { id: 'order_date', label: 'Order Date', alwaysVisible: false, defaultVisible: true, sortable: true, sortType: 'date' },
  { id: 'customer_name', label: 'Customer Name', alwaysVisible: false, defaultVisible: false, sortable: true, sortType: 'text' },
  { id: 'customer_email', label: 'Customer Email', alwaysVisible: false, defaultVisible: false, sortable: true, sortType: 'text' },
  { id: 'sold_by', label: 'Sold By', alwaysVisible: false, defaultVisible: false, sortable: true, sortType: 'text' },
  { id: 'device_name', label: 'Device', alwaysVisible: false, defaultVisible: false, sortable: false },
];

export const getDefaultVisibleColumns = () =>
  DONATION_COLUMNS.filter(c => c.defaultVisible);

export const getDefaultHiddenColumns = () =>
  DONATION_COLUMNS.filter(c => !c.defaultVisible && !c.alwaysVisible);
